var scrollingElement = require('_utils/scrolling-element');
var ko = require('knockout');
var $ = require('jquery');
var debounce = require('lodash/debounce');

function toIntArray(value) {
  var source = Array.isArray(value) ? value : String(value).split(',');
  var out = [];
  for (var i = 0; i < source.length; i++) {
    var n = parseInt(source[i], 10);
    if (!isNaN(n)) out.push(n);
  }
  return out;
}

function buildJsonPayload(filters) {
  var showAll = window.language && window.language.showAll;
  var payload = {};
  for (var key in filters) {
    if (!filters.hasOwnProperty(key)) continue;
    var value = filters[key];
    if (value === undefined || value === null || value === '') continue;
    if (key === 'year' && value === showAll) continue;
    if (key === 'category') {
      var cats = toIntArray(value);
      if (cats.length) payload.category = cats;
      continue;
    }
    if (key === 'name') {
      // The hash-helper carries the free-text search term as `name`, but the
      // ArticleQueryModel binds it from `Query`. Map it so the list filters by text.
      payload.Query = value;
      continue;
    }
    if (key === 'eventType' || key === 'year') {
      var n = parseInt(value, 10);
      if (!isNaN(n)) payload[key] = n;
      continue;
    }
    payload[key] = value;
  }
  return payload;
}

//TODO Lots of code duplication from organisms/course-list.js
function Model(params) {
  var self = this;

  if (params.listEndpoint === undefined) {
    throw 'listEndpoint must be set to fetch list';
  }

  var filterTopic = params.filterTopic || 'articleSearchFilterTopic';
  var itemsPerPage = params.itemsPerPage || 20;
  var takeMore = params.takeMore || 10;
  var articleListItem = params.articleListItem || 'article-block';
  var postAsJson = params.postAsJson === true;

  self.articleListItem = ko.observable(articleListItem);
  self.loading = ko.observable(false);

  self.currentScrollPosition = scrollingElement.scrollTop;
  self.currentFilters = ko
    .observable(params.defaultFilters)
    .subscribeTo(filterTopic, true);

  self.take = ko.observable(itemsPerPage);
  self.totalItems = ko.observable(9999999);
  self.ableToFetchMore = ko.computed(function() {
    return self.totalItems() > self.take();
  });
  self.activeArticlesAmount = ko.computed(function() {
    if (self.totalItems() > self.take()) {
      return self.take();
    } else {
      return self.totalItems();
    }
  });

  self.currentRelevanceSorting = ko
    .observable(false)
    .subscribeTo('currentRelevanceSorting', true);

  self.articleList = ko.observableArray([]);

  var currentPost;

  var updateList = function() {
    var filters = self.currentFilters() || {};

    if (typeof filters.category === 'string') {
      filters.category = filters.category.split(',');
    }

    filters.Skip = 0;
    filters.Take = self.take();

    filters.SortOnRelevance = self.currentRelevanceSorting();

    if (currentPost !== undefined) currentPost.abort();

    self.currentScrollPosition = scrollingElement.scrollTop;

    if (/json$/.test(params.listEndpoint)) {
      self.loading(true);
      window.setTimeout(function() {
        self.loading(false);
      }, 1000);

      currentPost = $.getJSON(params.listEndpoint, function(articles) {
        currentPost = undefined;
        self.articleList(articles.Items);
        self.totalItems(articles.TotalItems);
      });
    } else {
      self.loading(true);
      var done = function(articles) {
        currentPost = undefined;
        self.articleList(articles.Items);
        self.totalItems(articles.TotalItems);
      };
      var always = function() {
        self.loading(false);
      };
      if (postAsJson) {
        currentPost = $.ajax({
          url: params.listEndpoint,
          type: 'POST',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify(buildJsonPayload(filters))
        })
          .done(done)
          .always(always);
      } else {
        currentPost = $.post(params.listEndpoint, filters)
          .done(done)
          .always(always);
      }
    }
  };

  // In Microsoft browsers, re-rendering the list causes the window to be scrolled almost to the top. This callback ensures that when the list has re-rendered the scroll position is correct
  self.afterListRender = debounce(function() {
    if (self.currentScrollPosition !== scrollingElement.scrollTop) {
      scrollingElement.scrollTop = self.currentScrollPosition;
    }
  }, 15);

  self.getMoreArticles = function() {
    if (!self.loading()) {
      self.take(self.take() + takeMore);
      updateList();
    }
  };

  self.currentFilters.subscribe(function() {
    self.take(itemsPerPage);
    updateList();
  });
  self.currentRelevanceSorting.subscribe(updateList);

  // Initialize if we have received the filters.
  if (self.currentFilters() !== undefined) {
    updateList();
  }
}

module.exports = Model;
